module.exports = __webpack_public_path__ + "img/matters-empty.62772c83.png";